import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { urls } from 'helpers/url';
import { navigate } from 'actionCreators';
import { updatePhaseTask } from 'actionCreators/phase';
import PhaseTask from './phase_task';
import PhaseType from 'types/phase';
import TaskType from 'types/task';

export class CustomerReview extends PhaseTask {
  isDisabled = () => false

  onClick = () => (this.props.task.status !== 'complete' ?
  this.props.navigate(urls.phaseCommunications(this.props.phase)) :
    this.toggleStatus());
}

CustomerReview.propTypes = {
  phase: PhaseType.isRequired,
  task: TaskType.isRequired,
  updatePhaseTask: PropTypes.func.isRequired,
  navigate: PropTypes.func.isRequired,
};

const customer_review = connect(() => state => ({ user: state.user }),
  { updatePhaseTask, navigate })(CustomerReview);

export {
  customer_review as installation_customer_review,
  customer_review as workorder_customer_review,
};



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/components/tasks/customer_review.jsx